import styled from "styled-components";
import { Theme } from "../../../../@types/theme";

export const BoxCategories = styled.div`
  width: 400px;
  height: calc(100vh - 380px);
  background-color: white;
  overflow-y: scroll;
  position: absolute;
  z-index: 200;
  right: 0;
  top: 60px;
  -webkit-box-shadow: 0px 0px 15px -2px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 15px -2px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  padding: 1rem 2rem;
  z-index: 599;
  border-radius: 5px;
  border-color: ${({ theme }: Theme) => theme.colors.gray300};

  @media (max-width: 1366px) {
    top: 40px;
    height: (100vh - 300px);
    min-height: 225px;
  }
`;

export const LettersContainer = styled.div`
  width: 100%;
  min-height: 76px;
  border-bottom: 1px solid #c4c4c4;
  display: flex;
  flex-wrap: wrap;
  display: flex;
  padding-top: 2rem;

  @media (max-width: 1366px) {
    padding-top: 1rem;
  }

  .alphabetical {
    height: 20px;
    min-width: 10px;
    margin-right: 10px;
    background: transparent;
    font-size: 1.6rem;
    font-weight: normal;
  }

  #active {
    color: #663399 !important;
    font-weight: bold;
  }
`;

export const BodyCategories = styled.div`
  width: 100%;
  height: 100%;
  margin-bottom: 1rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 2rem 0;

  ::-webkit-scrollbar {
    width: 10px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #a5a5a5;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }

  @media (max-width: 1366px) {
    padding: 0;
  }
`;

export const ListItem = styled.div`
  font-size: 1.5rem;
  color: black;
  margin: 1rem 0;
  cursor: pointer;
  transition: all 120ms linear;

  &:hover {
    color: ${({ theme }) => theme.colors.background};
    font-weight: bold;
  }
`;
